import Card from '@/components/card/card-component';
import styled from 'styled-components';

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PriceSummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledCard = styled(Card)`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
`;

const QuotePriceContainer = styled.div`
  display: flex;
  width: 100%;
`;

const MessageContainer = styled.div`
  display: flex;
  flex: 1;
`;

const PriceContainer = styled.div`
  display: flex;
  margin-right: 16px;
  min-width: 180px;
`;

const GreyLine = styled.div`
  display: flex;
  height: 1px;
  background-color: ${({ theme }) => theme.COLOR_GREY5};
`;

const priceFormStyle = {
  StyledRow,
  StyledColumn,
  PriceSummaryContainer,
  StyledCard,
  QuotePriceContainer,
  MessageContainer,
  PriceContainer,
  GreyLine,
};

export default priceFormStyle;
